module.exports = __webpack_public_path__ + "static/media/terrible-intro.7f44ba03.mp3";